/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {BaseComponent, BaseEntityModel, FileService, Picture, PictureInput} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {translations} from '../../../../environments/translations.ru';
import {CrudEvent} from '../../interfaces/crud-event';

@Component({
  selector: 'app-picture',
  templateUrl: './picture.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PictureComponent extends BaseComponent implements OnChanges {
  @Input() entityModel: BaseEntityModel;
  @Input() entityPicture: Picture;
  @Input() pictureField: FormlyFieldConfig[];
  @Input() title: string = 'Фотография';
  @Input() width = 200;
  @Input() uri: string;
  @Output() pictureEvent = new EventEmitter<CrudEvent>();

  form = new UntypedFormGroup({});
  options: FormlyFormOptions = {
    formState: {
      disabled: false,
    }
  };
  model: PictureInput = {pictureInput: null};
  picture: Picture;
  isModal: false;
  fileName = '';
  showUploader = false;

  constructor(readonly fileService: FileService) {
    super();
  }

  toggleUploader() {
    this.showUploader = !this.showUploader;
  }

  get addIcon() {
    return this.showUploader ? 'minus-outline' : 'plus-outline';
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.pictureEvent.emit(CrudEvent.UPLOADING);

      this.model.pictureInput = this.form.controls.pictureInput.value;

      this.compoApiService
        .postForm<PictureInput, string>(this.uri, this.model)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(_ => {
          this.reset();
          this.pictureEvent.emit(CrudEvent.UPDATE_PICTURE);
        });
    }
  }

  ngOnChanges() {
    this.picture = this.entityPicture ? this.entityPicture : this.entityModel?.picture;

    if (this.picture) {
      if (!this.width || this.picture.type === 'SVG') {
        this.fileName = this.fileService.getImageUri(this.picture, 'originals');
      } else {
        this.fileName = this.fileService.getImageUri(this.picture, this.width);
      }
    }
  }

  get original(): string {
    return this.picture ? this.fileService.getImageUri(this.picture, 'originals') : '';
  }

  public onDeleteConfirm() {
    this.confirm(translations.confirmDelete + ' ' + translations.photo + '?', new Observable(() => {
      this.pictureEvent.emit(CrudEvent.DELETE_PICTURE);
      this.reset();
    }));
  }

  protected reset(): void {
    this.model = {pictureInput: null};
    this.picture = null;
    this.fileName = null;
    this.showUploader = false;
  }
}
